/* @flow */
import Group from 'entities/Group';
import ArchivedClassesListItem from './ArchivedClassesListItem';
import * as React from 'react';
import Text from 'components/Text';
// eslint-disable-next-line no-unused-vars
import type { Element } from 'react';

export default class ArchivedClassesList extends React.Component<{
  archivedClasses: Group[],
  canCreateGroups: boolean,
  onActionCompletion: () => void,
}> {
  renderArchivedClassesList(): Array<React.Element> | React.Element {
    const { canCreateGroups, onActionCompletion } = this.props;

    if (this.props.archivedClasses.length > 0) {
      return this.props.archivedClasses.map(archivedClass => {
        return (
          <ArchivedClassesListItem
            archivedClass={archivedClass}
            key={archivedClass.id}
            canCreateGroups={canCreateGroups}
            onActionCompletion={onActionCompletion}
          />
        );
      });
    } else {
      return this.renderNoArchivedClasses();
    }
  }

  renderNoArchivedClasses() {
    return (
      <Text align="center" element="div" italic className="ArchivedClassesList-noClasses">
        No archived classes.
      </Text>
    );
  }

  render() {
    return <div className="ArchivedClassesList-table">{this.renderArchivedClassesList()}</div>;
  }
}
